import { render, staticRenderFns } from "./AffirmAuthorFeature.vue?vue&type=template&id=779cc52e&"
import script from "./AffirmAuthorFeature.vue?vue&type=script&lang=js&"
export * from "./AffirmAuthorFeature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports